import React from "react";
import "./ServiceDetail1.css";
import bgImage from "../images/ServiceDetail1.jpg"; // ✅ correct path

const ServiceDetail1 = () => {
  return (
   
      <div className="overlay">
        <h1 className="title">Services Details</h1>
        <div className="breadcrumb">
          <span className="home-link">Home</span>
          <span className="separator">›</span>
          <span className="current">Services Details</span>
        </div>
      </div>
  
  );
};

export default ServiceDetail1;
